<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="交易名称">
            <Dict dict="zhixi_product" :value="form.name" need-all="true"></Dict>
          </FormItem>
          <FormItem label="归属机构">
            <Input v-model="form.tenantId"></Input>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <tradepriceInfo ref="tradepriceInfoRef" @handle-search="handleSearch"></tradepriceInfo>
  </div>
</template>

<script>
import tradepriceInfo from './tradeprice-info'
import { getIds } from '@/libs/util'

export default {
  name: 'tradeprice-list',
  components: {
    tradepriceInfo
  },
  data () {
    return {
      columns: [
        { title: '机构', key: 'tenantName' },
        { title: '产品名称', key: 'name' },
        { title: '产品码', key: 'code' },
        { title: '定价',
          key: 'price',
          render: (h, params) => {
            return h('span', (params.row.price / 100).toFixed(2))
          } },
        { title: '创建人', key: 'crtUserId' },
        { title: '创建时间', key: 'crtTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.tradepriceInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.tradepriceInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.tradepriceInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('tradeprice', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('tradeprice', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
